<template>
<widget class="widget">
	<div v-if="isInstalled" class="alert alert-success install-flag"><i class="fa fa-check"></i> Installed to {{ app.AddonAppInstalled[0].ui_location ? app.AddonAppInstalled[0].ui_location : 'Main Apps Tab' }}</div>
	<div class="row">
		<div class="col-md-3 col-sm-3">
			<div class="d-flex align-items-center bg-light app-logo-box">
				<img v-if="app.logo_src" :src="app.logo_src">
			</div>
		</div>
		<div class="col-md-6 col-sm-9">
			<div class="app-details-box">
				<h2>{{app.app_name}}</h2>

				<div class="description-box"><pre>{{ app.description }}</pre></div>

				<p>By <em>{{ app.developer_name }}</em></p>
			</div>
		</div>
		<div class="col-md-3 col-sm-12">
			<div class="app-controls-box">
				<button v-if="editable" slot="header" class="btn btn-light float-right ml-1" v-on:click="$emit('edit')">
					<i class="fa fa-pencil-alt"></i>
					Re-publish...
				</button>

				<button v-if="isInstalled && !hideUninstallButton" slot="header" class="btn btn-light float-right ml-1" v-on:click="$emit('uninstall')">
					<i class="fa fa-toggle-off"></i>
					Uninstall
				</button>
				<template v-if="!isInstalled">
					<button v-if="!showInstallLocationSelect" style="position: relative;top: -1px" class="btn btn-success ml-1" v-on:click="showInstallLocationSelect = true">
						<i class="fa fa-toggle-on"></i>
						Install
					</button>

					<field v-if="showInstallLocationSelect" 
						label="Install to"
						col-class="stacked"
						:params="{type:'select',options:uiLocations}"
						v-model="installLocation"
						v-on:change="installTo">
					</field>
				</template>
			</div>
		</div>
	</div>

	<div class="meta-box bg-light">
		<table>
			<tr>
				<th>Last Published:</th>
				<td>{{ moment.utc(app.publish_date).local().format("MMM D, YYYY") }} <em>version {{ app.app_version }}</em></td>
			</tr>
		</table>
		<div v-if="app.support_website"><a :href="app.support_website" target="_blank"><i class="fa fa-external-link-alt"></i> More Details & Support</a></div>
		<div class="row">

			<div class="col-md-8">
				
			</div>
			<div class="col-md-4">
				
			</div>
		</div>
	</div>

</widget>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import Widget from "@/components/Widget"

export default {
	components: {
		Widget,
		Field
	},
	props: ["app","isInstalled","editable","hideUninstallButton"],
	data() {
		return {
			installLocation: "",
			showInstallLocationSelect:false,
			uiLocations: [
				'Main',
				//'Dashboard Widget',
				'Projects Module',
				'Project Record',
				'Services Module',
				'Service Record',
				'Equipment Module',
				'Health & Safety Module',
				//'Expenses Module',
				//'Time Logs Module',
				//'Library Module'
			],

		}
	},
	methods: {
		installTo(installLocation) {
			this.$emit('install',this.app.id,installLocation)
		}
	}
}
</script>

<style type="text/css" scoped>
	pre {
		font-family: inherit;
		font-size: inherit;
		white-space: pre-wrap;
	}

	.widget {
		margin-left: 7px;
		margin-right: 7px;
	}

	.install-flag {
		margin: -9px;
		margin-top: -19px;
		margin-bottom: 10px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		padding: 2px;
		padding-left: 10px;
	}

	.app-logo-box {
		width: 150px;
		height: 150px;
		padding: 20px;
		flex-basis: 150px;
		flex-grow: 0;
		flex-shrink: 0;
		margin: auto;
		margin-bottom: 20px;
	}

	.app-controls-box {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex-basis: 180px;
		flex-grow: 0;
		flex-shrink: 0;
		padding-right: 8px;
	}

	.app-controls-box>* {
		width: 100%;
	}

	.app-details-box {
		padding-left: 20px;
		padding-right: 20px;
		flex-grow: 1

	}

	.description-box {
		min-height: 100px;
	}

	.meta-box {
		margin-top: 10px;
		margin-left: -7px;
		margin-right: -7px;
		margin-bottom: -7px;
		padding: 10px;
	}
</style>